import { render, staticRenderFns } from "./RegularTables.vue?vue&type=template&id=3e8456de"
import script from "./RegularTables.vue?vue&type=script&lang=js"
export * from "./RegularTables.vue?vue&type=script&lang=js"
import style0 from "./RegularTables.vue?vue&type=style&index=0&id=3e8456de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports